/**
 * CK Video Modal
 *
 * Opens a fullscreen video popup when the "See How It Works" hero button is clicked.
 * The button is identified by its href="#video-modal" attribute (set in templates/index.json).
 * Event delegation is used so the handler survives any post-load DOM re-rendering.
 *
 * Modal HTML:  layout/theme.liquid  (search for "CK VIDEO MODAL")
 * Modal CSS:   assets/ck-custom.css (search for "CK VIDEO MODAL")
 *
 * To add your video: edit layout/theme.liquid and follow the comments inside
 * .ck-video-modal__video-wrap — replace the placeholder <div> with your embed.
 */

(function () {
  'use strict';

  const TRIGGER_SELECTOR = 'a[href="#video-modal"]';
  const MODAL_ID         = 'ck-video-modal';
  const OVERLAY_ID       = 'ck-video-modal-overlay';
  const CLOSE_ID         = 'ck-video-modal-close';

  const modal    = document.getElementById(MODAL_ID);
  const overlay  = document.getElementById(OVERLAY_ID);
  const closeBtn = document.getElementById(CLOSE_ID);
  const video    = document.getElementById('ck-how-it-works-video');

  if (!modal) return;

  // ── Open ──────────────────────────────────────────────────────────────────

  function openModal() {
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
    if (video) video.play();
  }

  // ── Close ─────────────────────────────────────────────────────────────────

  function closeModal() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (video) { video.pause(); video.currentTime = 0; }
  }

  // ── Event listeners ───────────────────────────────────────────────────────

  // Event delegation: catches the trigger click regardless of when the button
  // is added to the DOM (survives Horizon's section hydration re-renders).
  document.addEventListener('click', function (e) {
    if (e.target.closest(TRIGGER_SELECTOR)) {
      e.preventDefault();
      openModal();
    }
  });

  // Close button
  closeBtn.addEventListener('click', closeModal);

  // Click on the dimmed overlay (outside the modal box)
  overlay.addEventListener('click', closeModal);

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
      closeModal();
    }
  });

}());
